import { z } from "zod";

// zod 4 replaced zod 3's default message for a missing value ("Required") with
// "Invalid input: expected string, received undefined". Keep the zod 3 text for
// fields whose schema sets no message of its own; a schema-level `error` still
// wins over this fallback (#2151).
export const MISSING_VALUE_MESSAGE = "Required";

z.config({
  customError: (issue) =>
    issue.input === undefined &&
    (issue.code === "invalid_type" || issue.code === "invalid_value")
      ? MISSING_VALUE_MESSAGE
      : undefined,
});
